/**
 * @generated SignedSource<<76b860b6db029ffa3a773544c96c7d90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentQrCodeContent_pixQrCode$data = {
  readonly brCode: string | null | undefined;
  readonly id: string;
  readonly isRemoved: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActivePixCobValue_pixQrCode" | "PaymentDeleted_pixQrCode" | "PaymentLinkComment_pixQrCode" | "PaymentLinkQrCode_pixQrCode" | "PaymentLinkShareButton_pixQrCode" | "PaymentLinkTransactionDetails_pixQrCode">;
  readonly " $fragmentType": "PaymentQrCodeContent_pixQrCode";
};
export type PaymentQrCodeContent_pixQrCode$key = {
  readonly " $data"?: PaymentQrCodeContent_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentQrCodeContent_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentQrCodeContent_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRemoved",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_pixQrCode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkQrCode_pixQrCode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkShareButton_pixQrCode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkTransactionDetails_pixQrCode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActivePixCobValue_pixQrCode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentDeleted_pixQrCode"
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "a960c42005fa33baad89a36ff8e21b9b";

export default node;
